module.exports = __webpack_public_path__ + "img/github.34119f98.svg";